/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './pharmacy-stock-indent-map.reducer';

export const PharmacyStockIndentMapDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const pharmacyStockIndentMapEntity = useAppSelector(state => state.pharmacyStockIndentMap.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="pharmacyStockIndentMapDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.pharmacyStockIndentMap.detail.title">PharmacyStockIndentMap</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.pharmacyStockIndentMap.id">Id</Translate>
            </span>
          </dt>
          <dd>{pharmacyStockIndentMapEntity.id}</dd>
          <dt>
            <span id="indentedQty">
              <Translate contentKey="tinyMedicRestApp.pharmacyStockIndentMap.indentedQty">Indented Qty</Translate>
            </span>
          </dt>
          <dd>{pharmacyStockIndentMapEntity.indentedQty}</dd>
          <dt>
            <span id="fulfilledQty">
              <Translate contentKey="tinyMedicRestApp.pharmacyStockIndentMap.fulfilledQty">Fulfilled Qty</Translate>
            </span>
          </dt>
          <dd>{pharmacyStockIndentMapEntity.fulfilledQty}</dd>
          <dt>
            <span id="packs">
              <Translate contentKey="tinyMedicRestApp.pharmacyStockIndentMap.packs">Packs</Translate>
            </span>
          </dt>
          <dd>{pharmacyStockIndentMapEntity.packs}</dd>
          <dt>
            <span id="productType">
              <Translate contentKey="tinyMedicRestApp.pharmacyStockIndentMap.productType">Product Type</Translate>
            </span>
          </dt>
          <dd>{pharmacyStockIndentMapEntity.productType}</dd>
          <dt>
            <span id="productId">
              <Translate contentKey="tinyMedicRestApp.pharmacyStockIndentMap.productId">Product Id</Translate>
            </span>
          </dt>
          <dd>{pharmacyStockIndentMapEntity.productId}</dd>
          <dt>
            <span id="fromStockId">
              <Translate contentKey="tinyMedicRestApp.pharmacyStockIndentMap.fromStockId">From Stock Id</Translate>
            </span>
          </dt>
          <dd>{pharmacyStockIndentMapEntity.fromStockId}</dd>
          <dt>
            <span id="toStockId">
              <Translate contentKey="tinyMedicRestApp.pharmacyStockIndentMap.toStockId">To Stock Id</Translate>
            </span>
          </dt>
          <dd>{pharmacyStockIndentMapEntity.toStockId}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.pharmacyStockIndentMap.active">Active</Translate>
            </span>
          </dt>
          <dd>{pharmacyStockIndentMapEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.pharmacyStockIndentMap.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{pharmacyStockIndentMapEntity.cursor}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.pharmacyStockIndentMap.lastUpdated">Last Updated</Translate>
            </span>
          </dt>
          <dd>{pharmacyStockIndentMapEntity.lastUpdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.pharmacyStockIndentMap.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{pharmacyStockIndentMapEntity.microSec}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.pharmacyStockIndentMap.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>{pharmacyStockIndentMapEntity.timestampEntry}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.pharmacyStockIndentMap.requestingPharmacy">Requesting Pharmacy</Translate>
          </dt>
          <dd>{pharmacyStockIndentMapEntity.requestingPharmacy ? pharmacyStockIndentMapEntity.requestingPharmacy.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.pharmacyStockIndentMap.fulfillingPharmacy">Fulfilling Pharmacy</Translate>
          </dt>
          <dd>{pharmacyStockIndentMapEntity.fulfillingPharmacy ? pharmacyStockIndentMapEntity.fulfillingPharmacy.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.pharmacyStockIndentMap.indentItem">Indent Item</Translate>
          </dt>
          <dd>{pharmacyStockIndentMapEntity.indentItem ? pharmacyStockIndentMapEntity.indentItem.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/pharmacy-stock-indent-map" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/pharmacy-stock-indent-map/${pharmacyStockIndentMapEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default PharmacyStockIndentMapDetail;
